import { Link } from "react-router-dom";
import { Seo } from "../components/site/Seo";
import { Icon } from "../components/site/Icon";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="container-site flex min-h-[60vh] flex-col items-center justify-center py-24 text-center">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-teal">404</p>
        <h1 className="mt-4 font-display text-4xl font-semibold text-ink md:text-5xl">
          This page moved house.
        </h1>
        <p className="mt-4 max-w-md text-sm leading-relaxed text-ink/60">
          The page you're looking for doesn't exist — but your home's command centre is one click away.
        </p>
        <Link to="/" data-testid="notfound-home-btn" className="btn-primary mt-8">
          Back to Home <Icon name="ArrowRight" className="h-4 w-4" />
        </Link>
      </section>
    </>
  );
}
